import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import commonJP from './jp/common'

export const resources = {
  jp: {
    translation: commonJP,
  },
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      jp: {
        translation: commonJP,
      },
    },
    lng: 'jp',
    fallbackLng: 'jp',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export default i18n
